import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  IconButton
} from '@mui/material';
import { X } from 'lucide-react';

const ConfirmModal = ({
  open,
  onClose,
  onConfirm,
  title = 'Confirmation',
  content = 'Are you sure you want to perform this operation?',
  type = 'yesNo',
  maxWidth = 'xs',
}) => {
  const getButtons = () => {
    switch (type) {
      case 'yesNoCancel':
        return (
          <>
            <Button onClick={onClose} variant="outlined" color="inherit">
              Cancel
            </Button>
            <Button onClick={() => onClose('no')} variant="outlined" color="primary">
              No
            </Button>
            <Button onClick={() => { onConfirm(); onClose('yes'); }} variant="contained" color="primary">
              Yes
            </Button>
          </>
        );
      case 'yesNo':
        return (
          <>
            <Button onClick={() => onClose('no')} variant="outlined" color="primary">
              No
            </Button>
            <Button onClick={() => { onConfirm(); onClose('yes'); }} variant="contained" color="primary">
              Yes
            </Button>
          </>
        );
      case 'ok':
        return (
          <Button onClick={() => { onConfirm?.(); onClose('ok'); }} variant="contained" color="primary">
            OK
          </Button>
        );
      default:
        return null;
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => onClose('cancel')}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          bgcolor: '#f8f4ff',
        }
      }}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          bgcolor: '#edbc45',
          color: '#000',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          fontWeight: 600
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={() => onClose('cancel')}
          sx={{
            color: '#000',
            p: 0.5,
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.1)',
            }
          }}
        >
          <X size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ mt: 2 }}>
        <DialogContentText>{content}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        {getButtons()}
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmModal;
